import gql from 'graphql-tag';

import client from '../graphqlAPI';

const POST_EDIT_TICKET_MUTATION = gql`
  mutation Post(
    $id: String
    $date: String
    $description: ObjectLocalizationInput
    $subtitle: ObjectLocalizationInput
    $price: Float
    $currency: String
    $sellers: [SellerTicketInput]
    $show: Boolean
    $showFee: Boolean
    $showPastEndDate: Int
    $ticketName: String
    $ticketReadableName: ObjectLocalizationInput
    $ticketSlugName: String!
    $purchaseUrl: String,
    $status: TicketStatus,
    $tags: [String],
    $venueSlugName: String,
  ) {
    postEditTicket(
      id: $id
      date: $date
      description: $description
      subtitle: $subtitle
      price: $price
      currency: $currency
      sellers: $sellers
      show: $show
      showFee: $showFee
      showPastEndDate: $showPastEndDate
      ticketName: $ticketName
      ticketReadableName: $ticketReadableName
      ticketSlugName: $ticketSlugName
      purchaseUrl: $purchaseUrl,
      status: $status,
      tags: $tags,
      venueSlugName: $venueSlugName,
    ) {
      isAuth
      isEdited
      ticketSlugName
    }
  }
`;

const postEditTicket = async ({
  id, date, description, price, sellers, show, showPastEndDate, showFee, ticketName, ticketReadableName, ticketSlugName, currency, purchaseUrl, status, tags, subtitle, venueSlugName,
}) => {
  try {
    const result = await client
      .mutate({
        mutation: POST_EDIT_TICKET_MUTATION,
        variables: {
          id,
          date,
          description,
          subtitle,
          price,
          currency,
          sellers,
          show,
          showFee,
          showPastEndDate,
          ticketName,
          ticketReadableName,
          ticketSlugName,
          purchaseUrl,
          status,
          tags,
          venueSlugName,
        },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { postEditTicket: postEditTicketValidationData },
    } = result;

    if (postEditTicketValidationData) {
      return postEditTicketValidationData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postEditTicketValidationData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postEditTicket Error: ${error}`);
    return null;
  }
};

export default postEditTicket;
